<template>
  <div class="specials-multislider" id="specials-multislider" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="carousel carousel-fade slide" data-interval="6000" data-pause="null" data-ride="carousel" :id="carouselID">
      <ol class="carousel-indicators" v-if="brandName == 'Ford'">
        <li
          class="active"
          data-slide-to="0"
          :data-target="'#' + carouselID"
        ></li>
        <li
          data-slide-to="1"
          :data-target="'#' + carouselID"
          class=""
        ></li>
      </ol>
      <ol class="carousel-indicators" v-else>
        <li
          class="active"
          data-slide-to="0"
          :data-target="'#' + carouselID"
        ></li>
        <li
          data-slide-to="1"
          :data-target="'#' + carouselID"
          class=""
        ></li>
        <li v-if="images.trucks.length > 0"
          data-slide-to="2"
          :data-target="'#' + carouselID"
          class=""
        ></li>
      </ol>
      <div class="carousel-inner" v-if="brandName == 'Ford'">
        <div class="item active">
          <div class="slide-body" id="item-0" :style="{ backgroundImage: `url(${slide3bgFord})` }">
            <div class="caption-box">
              <h3>New {{ new Date().getFullYear() }} {{brandName}} {{images.suvs[0].modelName}}</h3>
              <h1 class="uppercase" style="font-size: 4rem;">Employee Pricing</h1>
              <h3 class="bigger" style="font-size: 2rem;">You Pay What We Pay</h3>
              <a class="btn slide-btn" href="#">Shop Now</a>
            </div>
            <div class="car-img-wrapper">
              <img role="presentation" src="../../static/images/carcuts/ford-bronco-2025.png" :alt="images.suvs[0].modelName">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="slide-body" id="item-1" :style="{ backgroundImage: `url(${slide3bgFord})` }">
            <div class="caption-box">
              <h3>New {{ new Date().getFullYear() }} {{brandName}}</h3>
              <h2 class="uppercase">{{images.suvs[3].modelName}}</h2>
              <h1 class="uppercase" style="font-size: 5rem;">3.9% APR</h1>
              <h3 class="bigger" style="font-size: 2rem;">For 60 Months</h3>
              <a class="btn slide-btn" href="#">Shop Now</a>
            </div>
            <div class="car-img-wrapper">
              <img role="presentation" src="../../static/images/carcuts/ford-explorer-2025.png" :alt="images.suvs[3].modelName">
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-inner" v-else>
        <div class="item active">
          <div class="slide-body" id="item-0" :style="{ backgroundImage: `url(${slide0bg})` }">
            <div class="caption-box">
              <h3>New {{ new Date().getFullYear() }} {{brandName}}</h3>
              <h2 class="uppercase">{{images.sedans[0].modelName}}</h2>
              <h1 class="uppercase">0% APR</h1>
              <h3 class="bigger">for 36 mos</h3>
              <a class="btn slide-btn" href="#">Shop Now</a>
            </div>
            <div class="car-img-wrapper">
              <img role="presentation" :src="images.sedans[0].angleView" :alt="images.sedans[0].modelName">
            </div>
          </div>
        </div>
        <div class="item">
          <div class="slide-body" id="item-1" :style="{ backgroundImage: `url(${slide1bg})` }">
            <div class="caption-box">
              <h3>New {{ new Date().getFullYear() }} {{brandName}}</h3>
              <h2 class="uppercase">{{images.suvs[0].modelName}}</h2>
              <h1 class="uppercase">0% APR</h1>
              <h3 class="bigger">for 36 mos</h3>
              <a class="btn slide-btn" href="#">Shop Now</a>
            </div>
            <div class="car-img-wrapper">
              <img role="presentation" :src="images.suvs[0].angleView" :alt="images.suvs[0].modelName">
            </div>
          </div>
        </div>
        <div class="item" v-if="images.trucks.length > 0">
          <div class="slide-body" id="item-2" :style="{ backgroundImage: `url(${slide2bg})` }">
            <div class="caption-box">
              <h3>New {{ new Date().getFullYear() }} {{brandName}}</h3>
              <h2 class="uppercase">{{images.trucks[0].modelName}}</h2>
              <h1 class="uppercase">0% APR</h1>
              <h2>for 36 mos</h2>
              <a class="btn slide-btn" href="#">Shop Now</a>
            </div>
            <div class="car-img-wrapper">
              <img role="presentation" :src="images.trucks[0].angleView" :alt="images.trucks[0].modelName">
            </div>
          </div>
        </div>
      </div>
      <button
        aria-label="Pause Automatic Slideshow"
        class="btn"
        id="toggle-carousel"
        tabindex="0"
      >
        <i aria-hidden="true" class="fa fa-pause"></i></button
      ><a
        aria-label="Previous Slide"
        class="left carousel-control"
        data-slide="prev"
        :href="'#' + carouselID"
        role="button"
        tabindex="0"
        ><span
          aria-hidden="true"
          class="glyphicon glyphicon-chevron-left"
        ></span
        ><span class="sr-only">Previous</span></a
      ><a
        aria-label="Next Slide"
        class="right carousel-control"
        data-slide="next"
        :href="'#' + carouselID"
        role="button"
        tabindex="0"
        ><span
          aria-hidden="true"
          class="glyphicon glyphicon-chevron-right"
        ></span
        ><span class="sr-only">Next</span></a
      >
    </div>
  </div>
</template>

<script scoped>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
import "../../static/font-awesome/font-awesome-4.7.0/css/font-awesome.css";

export default {
  props: ['images'],
  data() {
    return {
      slide0bg: require("../../static/images/specials-multislider/landscapebg3.jpg"),
      slide1bg: require("../../static/images/specials-multislider/landscape-sea-hills.jpg"),
      slide2bg: require("../../static/images/specials-multislider/background6.jpg"),
      slide3bgFord: require("../../static/images/specials-multislider/ford-multislider-bg-2025.jpg"),
      brand: this.$store.state.chosenBrand,
      carouselID: 'banners-carousel-hero'
    };
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
    (function($) {
      var slideStuff = {
        init: function() {
          var slideID = $("#specials-multislider div:first-child").attr("id");
          var carouselContainer = $('#' + slideID);
          var slideInterval = 6000;

          function toggleCaption() {
            carouselContainer.find('.caption-box').hide()
            var caption = carouselContainer.find('.active').find('.caption-box').addClass('animated fadeInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                function (){
                $(this).removeClass('animated fadeInDown')});
            caption.slideToggle();
          }

          function toggleCar() {
            carouselContainer.find('.car-img-wrapper').hide()
            var car = carouselContainer.find('.active').find('.car-img-wrapper').addClass('animated fadeInLeft').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                function (){
                $(this).removeClass('animated fadeInLeft')});
            car.slideToggle();
          }

          carouselContainer
            .carousel({
              interval: slideInterval,
              cycle: true
            })
            .on('slide.bs.carousel slid.bs.carousel', toggleCaption).trigger('slide.bs.carousel')
            .on('slide.bs.carousel slid.bs.carousel', toggleCar).trigger('slide.bs.carousel');
        }
      }

      var paused = false;
      var pauseButton = {
        init: function() {
          var slideId = $("#specials-multislider div:first-child").attr("id");
          var carouselContain = $('#' + slideId);

          carouselContain.carousel({
            interval: 6000,
            pause: 0,
          });
          pauseButton.togglePause();
          pauseButton.onKeyPress();
          pauseButton.slideControl();
        },

        togglePause: function() {
          $("#toggle-carousel").click(function() {
            var slideId = $("#specials-multislider div:first-child").attr("id");
            var carouselContain = $('#' + slideId);
            var state = (paused = !paused) ? "pause" : "cycle";
            carouselContain.carousel(state);
            $(this)
              .find("i")
              .toggleClass("fa-play fa-pause");
          });
        },

        onKeyPress: function(e) {
          $("#toggle-carousel").keydown(function(e) {
            if (
              e.key == " " ||
              e.key == "Enter" ||
              e.keyCode == 32 ||
              e.keyCode == 13
            ) {
              e.preventDefault();
              $(this).trigger("click");
            }
          });
        },

        slideControl: function() {
          $(".carousel-control").keydown(function(e) {
            if (
              e.key == " " ||
              e.key == "Enter" ||
              e.keyCode == 32 ||
              e.keyCode == 13
            ) {
              e.preventDefault();
              $(this).trigger("click");
            }
          });
        },
      };

      $(document).ready(slideStuff.init);
      $(document).ready(pauseButton.init);
    })(jQuery);
  }
};
</script>
<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.specials-multislider {
  width: 100%;
  position: relative;
  margin: auto;
  background: #000;
}
.specials-multislider .caption-box {
  color: var(--primary-dark);
  background: rgba(255, 255, 255, 0.85);
  font-size: 18px;
  text-align: center;
  padding: 2% 15px;
  position: absolute;
  top: 0px;
  left: 15%;
  height: 450px;
  width: 475px;
  color: var(--primary-dark);
}
.specials-multislider .slide-btn {
  color: #fff;
  background: var(--primary-color);
  font-size: 20px;
  text-transform: uppercase;
  padding: 8px 30px;
  border: 2px solid var(--primary-color);
  border-radius: 25px;
  margin: 30px auto 20px;
  overflow: hidden;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.specials-multislider .slide-btn:hover {
  color: var(--primary-color);
  background: transparent;
}
.specials-multislider[data-brand="cjdr"] .slide-btn {
  background: var(--secondary-color);
  border: 2px solid var(--secondary-color);
}
.specials-multislider[data-brand="cjdr"] .slide-btn:hover {
  color: var(--secondary-color);
}
.specials-multislider .slide-body {
  width: 100%;
  height: 450px;
  background-size: cover;
  background-position-y: 65%;
  background-position-x: center;
}
.specials-multislider .carousel-control {
  background-image: none;
  bottom: unset;
  top: 50%;
  font-size: 30px;
}
.specials-multislider .car-img-wrapper {
  position: absolute;
  top: 24%;
  left: 37%;
}
.specials-multislider .car-img-wrapper img {
  height: 300px;
}
.specials-multislider .caption-box {
  animation-delay: 0.1s;
  -webkit-animation-delay: 0.1s;
  -moz-animation-delay: 0.1s;
  -o-animation-delay: 0.1s;
  -moz-transition: none !important;
}
.specials-multislider .caption-box h3 {
  margin-bottom: 5px;
}
.specials-multislider .caption-box h2 {
  margin-top: 0;
  font-size: 2.8rem;
}
.specials-multislider .caption-box .uppercase {
  text-transform: uppercase;
  font-weight: 600;
}
.specials-multislider .caption-box .bigger {
  font-size: 2.8rem;
}
.specials-multislider .caption-box h1 {
  font-size: 6rem;
  margin-top: 20px;
}
.specials-multislider .car-img-wrapper {
  animation-delay: 0.1s;
  -webkit-animation-delay: 0.1s;
  -moz-animation-delay: 0.1s;
  -o-animation-delay: 0.1s;
  -moz-transition: none !important;
}
.specials-multislider .carousel-indicators {
  left: 45%;
  max-width: 200px;
  margin-left: auto;
}
#banners-carousel-hero.carousel-fade .carousel-inner .item {
  opacity: 0;
  transition-property: opacity;
}
#banners-carousel-hero.carousel-fade .carousel-inner .active {
  opacity: 1;
}
#banners-carousel-hero.carousel-fade .carousel-inner .active.left,
#banners-carousel-hero.carousel-fade .carousel-inner .active.right {
  left: 0;
  opacity: 0;
  z-index: 1;
}
#banners-carousel-hero.carousel-fade .carousel-inner .next.left,
#banners-carousel-hero.carousel-fade .carousel-inner .prev.right {
  opacity: 1;
}
#banners-carousel-hero.carousel-fade .carousel-control.left {
  display: none;
}
#banners-carousel-hero.carousel-fade .carousel-control.left:focus {
  display: block;
}
#banners-carousel-hero.carousel-fade .carousel-control.right {
  display: none;
}
#banners-carousel-hero.carousel-fade .carousel-control.right:focus {
  display: block;
}
#banners-carousel-hero.carousel-fade .carousel-control:focus > .glyphicon {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.specials-multislider .caption-box img {
  max-height: 280px;
}
.specials-multislider .red-disc {
  font-size: 11px;
  color: var(--primary-color);
  text-decoration: underline;
  cursor: pointer;
  display: block;
  margin: auto;
  background: transparent;
  border: none;
}
.specials-multislider .red-disc:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.specials-multislider #toggle-carousel {
  position: absolute;
  bottom: 0;
  color: #000;
  background: #fff;
  left: 10px;
}
#banners-carousel-hero .logo-img-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 18vw;
  height: auto;
}
@media all and (transform-3d), (-webkit-transform-3d) {
  #banners-carousel-hero.carousel-fade .carousel-inner > .item.next,
  #banners-carousel-hero.carousel-fade .carousel-inner > .item.active.right {
    opacity: 0;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  #banners-carousel-hero.carousel-fade .carousel-inner > .item.prev,
  #banners-carousel-hero.carousel-fade .carousel-inner > .item.active.left {
    opacity: 0;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  #banners-carousel-hero.carousel-fade .carousel-inner > .item.next.left,
  #banners-carousel-hero.carousel-fade .carousel-inner > .item.prev.right,
  #banners-carousel-hero.carousel-fade .carousel-inner > .item.active {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  #banners-carousel-hero.carousel-fade .carousel-inner .left .caption-box, #banners-carousel-hero.carousel-fade .carousel-inner .left .car-img-wrapper {
    display: none !important;
  }
}

@media (max-width: 1700px) and (min-width: 1501px) {
  .specials-multislider .car-img-wrapper {
    left: 40%;
  }
}

@media (max-width: 1500px) and (min-width: 1301px) {
  .specials-multislider .car-img-wrapper {
    left: 44%;
  }
}

@media (max-width: 1300px) and (min-width: 801px) {
  .specials-multislider .caption-box {
    left: 10%;
  }
}

@media (max-width: 1300px) and (min-width: 1001px) {
  .specials-multislider .car-img-wrapper {
    left: 42%;
  }
}

@media (max-width: 1200px) and (min-width: 1101px) {
  .specials-multislider .car-img-wrapper {
    top: 25%;
    left: 45%;
  }
}

@media (max-width: 1100px) and (min-width: 1001px) {
  .specials-multislider .car-img-wrapper {
    top: 30%;
    left: 49%;
  }
  .specials-multislider .car-img-wrapper img {
    height: 260px;
  }
}

@media (max-width: 1000px) and (min-width: 901px) {
  .specials-multislider .car-img-wrapper {
    top: 40%;
    left: 49%;
  }
  .specials-multislider .car-img-wrapper img {
    height: 250px;
  }
}

@media (max-width: 900px) and (min-width: 801px) {
  .specials-multislider .car-img-wrapper {
    top: 42%;
    left: 48%;
  }
  .specials-multislider .caption-box {
    left: 5%;
    width: 425px;
  }
  .specials-multislider .car-img-wrapper img {
    height: 220px;
  }
}

@media (max-width: 800px) and (min-width: 768px) {
  .specials-multislider .car-img-wrapper {
    top: 50%;
    left: 50%;
  }
  .specials-multislider .caption-box {
    left: 5%;
    width: 425px;
  }
  .specials-multislider .car-img-wrapper img {
    height: 200px;
  }
}

@media (max-width: 767px) {
  .specials-multislider .caption-box {
    left: 0;
    background: rgba(255, 255, 255, 0.75);
    width: 100%;
  }
  .specials-multislider .car-img-wrapper {
    left: 0;
    top: 62%;
    width: 100%;
  }
  .specials-multislider .car-img-wrapper img {
    max-height: 200px;
    height: unset;
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }
  .specials-multislider .carousel-indicators {
    left: 35%;
  }
  .specials-multislider .carousel-indicators li {
    border-color: #333;
  }
  .specials-multislider .carousel-indicators li.active {
    border-color: #333;
    background-color: #333;
  }
  .specials-multislider .carousel-control {
    color: #333;
  }
  .specials-multislider .slide-body {
    min-height: 600px;
  }
  .specials-multislider .caption-box {
    min-height: 600px;
  }
  .specials-multislider .slide-btn {
    margin: 10px auto;
  }
  .specials-multislider .caption-box h1 {
    font-size: 5rem;
    margin-top: 20px;
  }
  .specials-multislider .caption-box h2 {
    font-size: 2.5rem;
  }
}

@-webkit-keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(200%, 0, 0);
    transform: translate3d(200%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(200%, 0, 0);
    transform: translate3d(200%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.specials-multislider .fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}

.specials-multislider .animated {
  -webkit-animation-duration: .8s;
  animation-duration: .8s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

/* Specials Multislider */

body .specials-multislider[data-brand="ford"] .caption-box {
  background: rgba(255, 255, 255, 0.5);
  top: 20px;
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
  max-height: calc(390px + 1vh);
  border-radius: 10px;
  border: 1px solid #d5d5d5;
}

body .specials-multislider[data-brand="ford"] .caption-box img {
  max-height: calc(310px - 4vh - 4vw);
}

body .specials-multislider[data-brand="ford"] .carousel-indicators {
  width: 100%;
  left: 0px;
  max-width: 100%;
  bottom: 0px;
}

body .specials-multislider[data-brand="ford"] .carousel-indicators li {
  background-color: #b2b2b2;
  width: 30px;
  height: 3px;
  border: none;
}

body .specials-multislider[data-brand="ford"] .carousel-indicators .active {
  background-color: #000;
  width: 30px;
  height: 3px;
  margin: 1px 10px 1px 10px;
}

body .specials-multislider[data-brand="ford"] .slide-btn {
  color: #000000;
  color: var(--primary-dark);
  border: 1px solid #000000;
  border: 1px solid var(--primary-dark);
  background-color: rgba(255, 255, 255, 0);
  padding: 10px 30px;
  text-transform: capitalize;
  border-radius: 35px;
  margin: 25px auto 0px;
}

body .specials-multislider[data-brand="ford"] .slide-btn:hover {
  background-color: rgba(255, 255, 255, 0.6);
  color: #000;
}

body .specials-multislider[data-brand="ford"] .slide-body {
  height: 290px;
}

body .specials-multislider[data-brand="ford"] #banners-carousel-hero.carousel-fade .carousel-inner .item {
  background: #fff;
  height: 450px;
}

body .specials-multislider[data-brand="ford"] .car-img-wrapper img {
  max-height: 280px;
}

body .specials-multislider[data-brand="ford"] .red-disc {
   color: #333333;
   color: var(--primary-color);
}

@media (min-width: 1701px) {
  body .specials-multislider[data-brand="ford"] .car-img-wrapper {
    top: 25%;
    left: 50%;
  }
}

@media (max-width: 1700px) and (min-width: 768px) {
  body .specials-multislider[data-brand="ford"] .car-img-wrapper {
    left: 54%;
  }
}

@media (min-width: 1200px) {
  body .specials-multislider[data-brand="ford"] .car-img-wrapper {
    top: 37%;
  }
}

@media (max-width: 1199px) and (min-width: 992px) {
  body .specials-multislider[data-brand="ford"] .car-img-wrapper {
    top: 40%;
  }
}

@media (max-width: 992px) and (min-width: 768px) {
  body .specials-multislider[data-brand="ford"] .caption-box {
    left: 5%;
    width: 425px;
  }
  body .specials-multislider[data-brand="ford"] .car-img-wrapper {
    top: 42%;
  }
}

@media (max-width: 767px) {
  body .specials-multislider[data-brand="ford"] {
    background: #ffffff;
  }

  body .specials-multislider[data-brand="ford"] .caption-box {
    min-height: unset;
    height: unset;
    position: relative;
    top: 0px;
  }

  body .specials-multislider[data-brand="ford"] .slide-btn {
    margin: 15px auto;
    font-size: 16px;
    padding: 8px 26px 11px;
  }

  body .specials-multislider[data-brand="ford"] #banners-carousel-hero.carousel-fade {
    background: #fff;
  }

  body .specials-multislider[data-brand="ford"] #banners-carousel-hero.carousel-fade .carousel-inner .item {
    height: unset;
  }

  body .specials-multislider[data-brand="ford"] .slide-body {
    min-height: 65vh;
    padding: calc(2% + 30px);
    height: unset;
  }

  body .specials-multislider[data-brand="ford"] .slide-body:after {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: calc(12% + 5vh);
    background: #fff;
    z-index: 0;
  }

  body .specials-multislider[data-brand="ford"] .car-img-wrapper {
    position: relative;
    left: 0;
    top: 30px;
    z-index: 2;
  }

  body .specials-multislider[data-brand="ford"] .carousel-indicators {
    width: 100%;
    left: 0px;
  }
}

@media (min-width: 992px) {
  body .specials-multislider[data-brand="ford"] .red-disc {
   margin-top: 5px;
  }
}

</style>
